<template>
  <el-select
    :value="value"
    @change="onChange"
  >
    <el-option
      v-for="option in options"
      :key="option.value"
      :label="$t(option.label)"
      :value="option.value"
    />
  </el-select>
</template>

<script>
  import {
    STABILITY_FILTER_DEFAULT,
    STABILITY_FILTER_OPTIONS,
  } from '@/config/stabilityFilter';

  export default {
    name: 'StabilityFilter',
    props: {
      value: {
        type: String,
        default: STABILITY_FILTER_DEFAULT,
      },
    },
    data() {
      return {
        options: STABILITY_FILTER_OPTIONS,
      };
    },
    methods: {
      onChange(selected) {
        this.$emit('input', selected);
        this.$emit('change', selected);
      },
    },
  };
</script>
